import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Query } from '@apollo/client/react/components';
import {
  ErrorHandler,
} from '@playbookux/playbook-web-core';

import Banner from './banner';
import { GET_BANNERS, LIMIT } from '../../graphql';

const Banners = (props) => {
  const {
    companyId,
    userId,
  } = props;

  return (
    <Query
      query={GET_BANNERS}
      variables={{
        companyId,
        status: 'in_progress',
        testType: 'moderated',
        userId,
        dismissedBanner: true,
        limit: LIMIT,
      }}
      skip={!companyId || !userId}
      fetchPolicy="network-only"
    >
      {({ error: errorBanner, data: dataBanner = {} }) => {
        if (errorBanner) {
          return (
            <ErrorHandler
              error={errorBanner}
              defaultMessage="Error while retrieving projects information."
            />
          );
        }

        return (
          <>
            {_.map(dataBanner.projects, ({ id, name }) => (
              <Banner
                key={`${id}-${userId}`}
                companyId={companyId}
                id={id}
                projectName={name}
                userId={userId}
              />
            ))}
          </>
        );
      }}
    </Query>
  );
};

Banners.propTypes = {
  companyId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default Banners;
